export default __webpack_public_path__ + "img/hamburger-menu.47fc9a32.svg";